import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { pageClick } from '@wix/bi-logger-new-help-center/v2';
import { useBI } from '../../../hooks/useBI';
import { BI } from '../../../constants';

export const useExternalSearchFilterBi = () => {
  const { sendBIEvent } = useBI();
  const { locale } = useRouter();

  const onClickFilter = useCallback(async (selectedFilterText: string) => {
    await sendBIEvent(
      pageClick({
        source_name: BI.SOURCE_NAMES.ROADMAP,
        clicked_item_type: BI.CLICKED_ITEM_TYPES.TAB_SELECTION,
        clicked_text: selectedFilterText,
        kb_lang: locale as string,
      })
    );
  }, []);

  return {
    onClickFilter,
  };
};
